// src/desktop/ui/notificationslog.js
import {
  CATEGORY_CONFIG,
  groupByCategory,
  createNotificationBanner,
  getNotifications,
} from './notification-log-helpers.js';
import { formatDateTime } from '../../../../../shared/utils/timeformats.js';

export async function openNotificationsLog(unit) {
  const modal = document.getElementById('notificationsLogModal');
  const closeBtn = document.getElementById('closeNotificationsLog');
  const reportContent = document.getElementById('notificationsLogReport');
  const emptyEl = document.getElementById('notificationsLogEmpty');

  if (!modal || !reportContent) {
    console.error('Notifications log modal elements not found in DOM');
    return;
  }

  // wire close only once
  if (!closeBtn.dataset.bound) {
    closeBtn.addEventListener('click', (e) => {
      e.stopImmediatePropagation();
      modal.style.display = 'none';
    });
    closeBtn.dataset.bound = 'true';
  }

  modal.style.display = 'block';
  reportContent.innerHTML = `<div class="loading-message">Loading notification logs...</div>`;
  emptyEl.style.display = 'none';

  try {
    let items = await getNotifications(unit);

    // newest first
    items.sort(
      (a, b) =>
        new Date(b.ts || b.timestamp || 0) -
        new Date(a.ts || a.timestamp || 0)
    );

    if (!items.length) {
      reportContent.innerHTML = '';
      emptyEl.style.display = 'block';
      return;
    }

    const grouped = groupByCategory(items);

    reportContent.innerHTML = '';
    emptyEl.style.display = 'none';

    CATEGORY_CONFIG.forEach((cfg) => {
      const section = createDesktopCategorySection(cfg, grouped[cfg.key] || []);
      reportContent.appendChild(section);
    });
  } catch (err) {
    console.error('Failed to load notifications (desktop):', err);
    reportContent.innerHTML = `<div class="error-message">Failed to load notifications.</div>`;
  }
}

function createDesktopCategorySection(cfg, items) {
  const section = document.createElement('div');
  section.className = 'notifications-section';
  section.id = `${cfg.key}Section`;

  const header = document.createElement('div');
  header.className = 'notifications-header';

  const iconDiv = document.createElement('div');
  iconDiv.className = 'notifications-icon';
  const img = document.createElement('img');
  img.src = cfg.icon;
  img.alt = `${cfg.label} icon`;
  img.width = 35;
  img.height = 35;
  iconDiv.appendChild(img);

  const title = document.createElement('div');
  title.className = 'notifications-title';

  let lastDateText = '';
  if (items.length) {
    const latest = items[0]; // newest first because you sorted earlier
    const ts = new Date(latest.ts || latest.timestamp || Date.now());
    lastDateText = formatDateTime(ts);
  }

  const labelSpan = document.createElement('span');
  labelSpan.textContent = cfg.label;
  title.appendChild(labelSpan);

  if (lastDateText) {
    const dateSpan = document.createElement('span');
    dateSpan.className = 'notifications-last-date';
    dateSpan.textContent = ` ${lastDateText}`;
    title.appendChild(dateSpan);
  }

  const count = document.createElement('div');
  count.className = 'notifications-count';
  count.textContent = items.length ? `${items.length}` : '0';

  const toggleButton = document.createElement('button');
  toggleButton.className = 'toggle-button';
  toggleButton.setAttribute('aria-expanded', 'false');
  toggleButton.innerHTML = `<span class="chev">+</span>`;

  header.appendChild(iconDiv);
  header.appendChild(title);
  header.appendChild(count);
  header.appendChild(toggleButton);

  const logContainer = document.createElement('div');
  logContainer.className = 'log-container';
  logContainer.id = `${cfg.key}-log`;

  if (!items.length) {
    const empty = document.createElement('div');
    empty.className = 'empty-notifications';
    empty.textContent = 'No Notifications';
    logContainer.appendChild(empty);
  } else {
    const wrap = document.createElement('div');
    wrap.className = 'notifications-wrap';
    items.forEach((n) =>
      wrap.appendChild(createNotificationBanner(n, document))
    );
    logContainer.appendChild(wrap);
  }

  toggleButton.addEventListener('click', () => {
    const open = logContainer.classList.toggle('show');
    toggleButton.setAttribute('aria-expanded', String(open));
    //toggleButton.classList.toggle('active', open);

    const icon = toggleButton.querySelector('.chev');
    icon.textContent = open ? '−' : '+';   // plus when closed, minus when open
  });

  section.appendChild(header);
  section.appendChild(logContainer);
  return section;
}
